/* tslint:disable */
/* eslint-disable */
/**
 * Logistics
 * 物流管理用API
 *
 * The version of the OpenAPI document: 1.0
 * Contact: kiuchi@wcdi.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { GetCheckout200ResponseAllOfData } from './GetCheckout200ResponseAllOfData';
import {
    GetCheckout200ResponseAllOfDataFromJSON,
    GetCheckout200ResponseAllOfDataFromJSONTyped,
    GetCheckout200ResponseAllOfDataToJSON,
} from './GetCheckout200ResponseAllOfData';

/**
 * 
 * @export
 * @interface GetCheckout200Response
 */
export interface GetCheckout200Response {
    /**
     * 
     * @type {GetCheckout200ResponseAllOfData}
     * @memberof GetCheckout200Response
     */
    data: GetCheckout200ResponseAllOfData;
    /**
     * 
     * @type {object}
     * @memberof GetCheckout200Response
     */
    meta: object;
}

/**
 * Check if a given object implements the GetCheckout200Response interface.
 */
export function instanceOfGetCheckout200Response(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "data" in value;
    isInstance = isInstance && "meta" in value;

    return isInstance;
}

export function GetCheckout200ResponseFromJSON(json: any): GetCheckout200Response {
    return GetCheckout200ResponseFromJSONTyped(json, false);
}

export function GetCheckout200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetCheckout200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': GetCheckout200ResponseAllOfDataFromJSON(json['data']),
        'meta': json['meta'],
    };
}

export function GetCheckout200ResponseToJSON(value?: GetCheckout200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': GetCheckout200ResponseAllOfDataToJSON(value.data),
        'meta': value.meta,
    };
}

